///home/natalija/django_react_RNA/frontend/src/features/workflows/components/RunPanel.jsx

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { WORKFLOW_BY_ID } from '../config/pipelines';

export function RunPanel({ pipeline, onClose }) {
  const navigate = useNavigate();
  const workflow = WORKFLOW_BY_ID[pipeline];
  const panelTitle = workflow?.title ?? pipeline;
  const batchesPath = `/workflow/batches?pipeline=${pipeline || ''}`;

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h3 className="text-2xl font-semibold">
          {workflow?.modalTitle ?? `${panelTitle} Analysis`}
        </h3>
        <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
          ✕
        </button>
      </div>

      <div className="space-y-4">
        <p className="text-sm text-gray-600">
          Start {panelTitle} analysis from the batch workspace. Create or manage batches first,
          then launch runs from within the batch context.
        </p>
        <div className="flex flex-wrap gap-3">
          <button
            onClick={() => navigate(batchesPath)}
            className="rounded-lg border border-slate-200 bg-slate-900 px-4 py-2 text-white hover:bg-slate-800"
          >
            Open batch workspace
          </button>
          <button
            onClick={onClose}
            className="rounded-lg border border-slate-200 bg-white px-4 py-2 text-slate-700 hover:border-slate-300"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
